<template>
  <div class="el-popover el-popper step p-3" :id="stepId" :ref="stepId">
    <div class="d-flex justify-content-between">
      <div v-if="step.title" class="el-popover__title">
        <div>{{ step.title }}</div>
      </div>
      <span @click.prevent="finish" class="cursor-pointer"><i class="material-icons md-18">close</i></span>
    </div>

    <div class="tourguide_content">
      <div v-if="step.content" v-html="step.content"></div>
    </div>

    <div v-if="numberOfSteps > 1" class="d-flex justify-content-between align-items-center mt-3">
      <div class="tourguide_navigate">
        <el-button v-if="!isFirst" @click.prevent="previousStep" class="material-icons md-18"
          >keyboard_arrow_left
        </el-button>
      </div>
      <div>
        <span class="">{{ `${currentStep + 1}/${numberOfSteps}` }}</span>
      </div>
      <div class="tourguide_navigate">
        <el-button v-if="!isLast" @click.prevent="nextStep" class="material-icons md-18"
          >keyboard_arrow_right
        </el-button>
      </div>
    </div>

    <div class="step__arrow" data-popper-arrow></div>
  </div>
</template>

<script>
import { createPopper } from '@popperjs/core'
import { DEFAULT_OPTIONS } from './popper-options'

export default {
  name: 'Step',
  props: {
    step: {
      type: Object,
    },
    currentStep: {
      type: Number,
    },
    numberOfSteps: {
      type: Number,
    },
    previousStep: {
      type: Function,
    },
    nextStep: {
      type: Function,
    },
    stop: {
      type: Function,
    },
    isFirst: {
      type: Boolean,
    },
    isLast: {
      type: Boolean,
    },
    startTour: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      stepId: `step-${this.uuid}`,
      targetElement: document.querySelector(this.step.target),
      options: DEFAULT_OPTIONS,
      position: null,
    }
  },
  methods: {
    elementIsVisible(element) {
      const rect = element.getBoundingClientRect()
      const result =
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)

      return {
        result,
        top: rect.top,
      }
    },
    createStep() {
      if (this.targetElement) {
        this.createHighlight()
        const targetIsVisible = this.elementIsVisible(this.targetElement)

        if (!targetIsVisible.result) {
          window.scrollTo(0, targetIsVisible.top)
        }

        createPopper(this.targetElement, this.$refs[this.stepId], this.options)
      } else {
        this.$emit('targetNotFound', this.step)
        this.nextStep()
      }
    },
    createHighlight() {
      if (!this.targetElement) return
      this.targetElement.style['z-index'] = 2500
      const elementPosition = window.getComputedStyle(this.targetElement).position
      if (!['fixed', 'relative', 'absolute'].includes(elementPosition)) {
        this.targetElement.style['position'] = 'relative'
      }
      const modal = document.createElement('div')
      modal.classList.add('v-modal')
      modal.setAttribute('id', 'helpy-highlight-modal')
      modal.style['z-index'] = 2375
      this.targetElement.parentNode.appendChild(modal)
    },
    removeHighlight() {
      if (!this.targetElement) return

      this.targetElement.style['z-index'] = null
      const modal = document.getElementById('helpy-highlight-modal')
      modal.remove()
    },
    finish() {
      document.querySelectorAll('.tableFixHead thead tr th, tr.twoHeader th').forEach((element) => {
        element.style['position'] = 'sticky'
      })
      this.stop()
    },
  },
  mounted() {
    this.createStep()
  },
  destroyed() {
    this.removeHighlight()
  },
}
</script>

<style lang="scss" scoped>
.step {
  width: 400px;
  border-radius: 8px;
  z-index: 2500;
}
.step__arrow,
.step__arrow::before {
  position: absolute;
  width: 10px;
  height: 10px;
  background: inherit;
}
.step__arrow {
  visibility: hidden;
}
.step__arrow::before {
  visibility: visible;
  content: '';
  transform: rotate(45deg);
}
.step[data-popper-placement^='top'] > .step__arrow {
  bottom: -5px;
}
.step[data-popper-placement^='bottom'] > .step__arrow {
  top: -5px;
}
.step[data-popper-placement^='right'] > .step__arrow {
  left: -5px;
}
.step[data-popper-placement^='left'] > .step__arrow {
  right: -5px;
}
.cursor-pointer {
  cursor: pointer;
}
.el-button--default {
  border: none;
  padding: 0;
}
.tourguide_navigate {
  min-width: 18px;
}
</style>
